import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { getFavoriteQuestions, recordAnswer } from "../lib/store";
import { InteractiveQuestion } from "../components/InteractiveQuestion";
import { Star, ChevronRight } from "lucide-react";

export default function Favoris() {
  const { level } = useApp();
  const [list, setList] = useState(() => getFavoriteQuestions(level));

  useEffect(() => {
    setList(getFavoriteQuestions(level));
  }, [level]); // eslint-disable-line react-hooks/exhaustive-deps

  const onFavChange = (qid, added) => {
    if (!added) setList((l) => l.filter((q) => q.id !== qid));
  };

  return (
    <div className="space-y-8">
      <div>
        <div className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-warning">
          <Star size={14} /> Favoris
        </div>
        <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight mt-2">Mes favoris</h1>
        <p className="text-muted-foreground mt-2 text-sm max-w-xl">
          Retrouvez ici les questions que vous avez épinglées avec l'étoile. Retirez-en une en cliquant à nouveau sur l'étoile.
        </p>
      </div>

      {list.length === 0 ? (
        <div className="rounded-sm border border-dashed border-border bg-card p-10 text-center">
          <Star size={40} className="text-muted-foreground mx-auto mb-4" />
          <p className="text-sm text-muted-foreground">
            Aucune question en favori pour le moment. Cliquez sur l'étoile ⭐ d'une question pour l'ajouter.
          </p>
          <Link to="/etudier" className="mt-5 inline-flex items-center gap-2 rounded-sm bg-primary text-primary-foreground px-5 py-2.5 font-semibold">
            Parcourir les questions <ChevronRight size={18} />
          </Link>
        </div>
      ) : (
        <div className="space-y-3">
          {list.map((q, i) => (
            <InteractiveQuestion
              key={q.id}
              q={q}
              index={i}
              onAnswered={(ok, qq) => recordAnswer(level, qq.id, ok)}
              onFavChange={onFavChange}
              testPrefix="fav-q"
            />
          ))}
        </div>
      )}
    </div>
  );
}
